import $ from 'jquery';
import BaseController from './BaseController';

class MiniCartController extends BaseController {

    initialize() {
        super.initialize();
        this.actions.addAction('mini_cart_ready', () => {
            super.initialize();
        });
        this.actions.addAction('cart_updated', this.onCartUpdated.bind(this));
    }

    onCartUpdated(cart) {
        if (!this.cart.isEmpty()) {
            if (this.gateway.isPaymentSheetOpen()) {
                return;
            }

            if (cart.hasChanged('needsShipping')) {
                this.gateway.destroyPaymentElement();
            }

            super.initialize();
        }
    }

    onPaymentElementReady() {
        $(this.selector).show();
        super.onPaymentElementReady();
    }

    getElementContainer() {
        let el = document.querySelector(this.selector);
        const gatewayId = this.gateway.id;
        const gatewayIdHyphenated = gatewayId.replace(/_/g, '-');
        const queries = [
            `.wc-${gatewayIdHyphenated}-mini-cart`,
            `.wc-${gatewayId}-mini-cart`,
            `.wc-${gatewayId}-minicart`,
        ];
        if (!el) {
            for (const query of queries) {
                el = document.querySelector(query);
                if (el) {
                    this.selector = query;
                    return super.getElementContainer();
                }
            }
            if (!el) {
                $('.woocommerce-mini-cart__buttons').prepend(`<a class="wc-${gatewayId}-mini-cart"></a>`);
            }
        }
        return super.getElementContainer();
    }
}

export default MiniCartController;